import { useSelector } from "react-redux"
import { NoteArticleTab } from "./NoteArticleTab"
import {
	selectNoteArticleTabsCurrentIndexV2,
	selectNoteArticleTabsInsertionOrder,
	selectNoteArticleTabsListV2
} from "../../../reducers/noteArticleTabsV2Slice"
import SecondaryToolbarTabs from "../../../utils/SecondaryToolbarTabs"
import {useWorkspaceContext} from "../../../pages/Dashboard"

export function NoteArticleListPanelNav() {
	const {workspaceId} = useWorkspaceContext()
	const tabs = useSelector((state) => selectNoteArticleTabsListV2(state, workspaceId))
	const currentIndex = useSelector((state) => selectNoteArticleTabsCurrentIndexV2(state, workspaceId))
	const insertionOrder = useSelector((state) => selectNoteArticleTabsInsertionOrder(state, workspaceId))

	return tabs ?
		(
			<SecondaryToolbarTabs
				value={currentIndex}
				scrollButtons
				allowScrollButtonsMobile
				TabIndicatorProps={{
					style: {
						opacity: Object.values(tabs).length >= 1 ? 1 : 0
					},
				}}
				variant={"scrollable"}
			>
				{insertionOrder.map((tabId) =>
					(
						<NoteArticleTab
							key={tabId}
							value={tabId}
							tab={tabs[tabId]}
							index={tabId}
						/>
					))}
			</SecondaryToolbarTabs>
		)
		:
		(
			<span></span>
		)
}